import React, { useState } from "react";
import { Preview } from "../components/organisms";

const withPreview = (Component) => {
  function WrapComponent(props) {
    const [open, setOpen] = useState(false);
    const [title, setTitle] = useState(null);
    const [fileName, setFileName] = useState(null);
    // const [urlPreview, setUrlPreview] = useState(null);

    function handleClickOpenPreview({ filename, log_id }) {
      setTitle(log_id);
      setFileName(filename || log_id);
      // setUrlPreview(url_preview);
      // services.outputs.preview(log_id, (rRes) => {
      //   const pdf = document.querySelector("#preview-pdf");
      //   console.log("preview-pdf", pdf);

      //   // pdf.data = URL.createObjectURL(rRes);
      //   // console.log(pdf.src);
      // });
      setOpen(true);
    }

    function handleClickClosePreview(pCallback) {
      setTitle(null);
      setFileName(null);
      // setUrlPreview(null);
      setOpen(false);
    }

    const xProps = {
      ...props,
      isPreviewOpen: open,
      onClickOpenPreview: handleClickOpenPreview,
      onClickClosePreview: handleClickClosePreview,
    };

    return (
      <>
        <Component {...xProps} />
        <Preview
          open={open}
          title={title}
          fileName={fileName}
          logID={title}
          onClose={handleClickClosePreview}
        />
      </>
    );
  }

  return WrapComponent;
};

export default withPreview;
